/** @format */

/** @format */
import { useState } from 'react'
import { _$, Message } from '@king-design/react'
import { handleDateFormat, IMonitorGraphData } from './constants'
import API from 'src/api/ApiDashboard'
import dayjs from 'dayjs'
import { request, keepDecimal, handleUnit } from 'src/utils'
import { useAsyncFn } from 'react-use'
// eslint-disable-next-line max-len
import { aggregator_menu } from 'src/containers/MonitorDashboard/Customboard/EditGraphMetricFormItem'
import { isNumber } from 'lodash'
const calcAggData = (data: any[], xDate: number[], agg: string) => {
  if (data?.length && xDate?.length) {
    const concatData = []
    for (let i = 0; i < xDate.length; i++) {
      const curData = data.map(item => item[i])
      concatData.push(curData)
    }
    const calcData = concatData.map(item => {
      const filterNull = item.filter(item => item !== undefined)
      if (filterNull.length === 0) {
        return undefined
      }
      if (agg === 'max') {
        return keepDecimal(Math.max.apply(null, filterNull))
      } else if (agg === 'min') {
        return keepDecimal(Math.min.apply(null, filterNull))
      } else if (agg === 'average') {
        return keepDecimal(filterNull.reduce((pre, cur) => (pre += cur), 0) / filterNull.length)
      } else if (agg === 'sum') {
        return keepDecimal(filterNull.reduce((pre, cur) => (pre += cur), 0))
      } else {
        return undefined
      }
    })
    return calcData
  } else {
    return []
  }
}

// 查找是否有重复的legend
const getChartLegend = (legend, seriesData, instanceId) => {
  const findLegend = seriesData.find(({ name }) => name.split('===')[0] === legend)
  if (!findLegend) {
    return legend
  }
  const lastInstance = instanceId.substr(-6)
  const legendId = `${legend}-${lastInstance}`
  const findLegendId = seriesData.find(({ name }) => name.split('===')[0] === legendId)
  return findLegendId ? `${legendId}-(重复)` : legendId
}

// 正则取legend中的instanceName和tag
const getLegnedData = str => {
  const regex = /(?:\(([^)]+)\)|\[([^\]]+)\])/g
  const matches = []
  let match
  while ((match = regex.exec(str)) !== null) {
    if (match[1]) matches.push(match[1]) // 提取括号内容
    if (match[2]) matches.push(match[2]) // 提取方括号内容
  }
  return matches
}
const getMetricStatisticsBatch = (graph?: IMonitorGraphData) => {
  const [chartData, setChartData] = useState<any>()
  const handleGraph = (start, end, delay, newGraph: IMonitorGraphData) => {
    const cloneMetrics = []
    let lineCount = 0
    newGraph.metrics.forEach((metric, index) => {
      const {
        graphMetricId,
        productType,
        instances,
        metricKey,
        metricName,
        metricTags,
        units,
        aggregator,
        resourceAggregator,
        tagsAggregator
      } = metric
      const m = {
        GraphMetricId: graphMetricId || 0 - index,
        ProductType: productType,
        MetricKey: metricKey,
        MetricName: metricName,
        Delay: delay,
        Units: units,
        Instances: [],
        metricTags: metricTags || [],
        Aggregator: aggregator || 'max',
        ResourceAggregator: resourceAggregator || '',
        TagsAggregator: tagsAggregator || ''
      }
      if (instances?.length) {
        instances.forEach(instance => {
          lineCount += 1
          m.Instances.push(instance.instanceId)
        })
      }
      cloneMetrics.push(m)
    })
    return {
      DashboardId: newGraph?.dashboardId,
      StartTime: start,
      EndTime: end,
      Period: delay,
      Metrics: cloneMetrics,
      LineCount: lineCount
    }
  }
  // 获取图表数据
  const getDashboardChart = async (
    startTime: number,
    endTime: number,
    delay,
    newGraph?: IMonitorGraphData,
    dataFormat?: string,
    tip = true,
    noloading = false
  ) => {
    const graphData = newGraph || graph
    const firstMetric = graphData?.metrics[0]
    // 是否有数据
    if (!firstMetric?.metricKey || !delay) {
      setChartData(undefined)
      return Promise.resolve(undefined)
    }
    const params = handleGraph(startTime, endTime, delay, graphData)
    // 实例是否超过100条
    if (params.LineCount > 1000) {
      tip && Message.error(_$('单个视图最多可添加1000条监控数据'))
      setChartData({})
      return
    }
    const result = await fetch(params, startTime, endTime, delay, dataFormat, noloading)
    setChartData(result)
    return result
  }
  const [{ loading }, fetch] = useAsyncFn(
    async (params, startTime, endTime, delay, dataFormat, noloading) => {
      const result = await request(API.DescribeDashboardMetricsData, {
        method: 'POST',
        data: params,
        noloading
      })
      if (result?.code === 'Success') {
        const { data } = result.data
        let findLine
        data.some(item => {
          findLine = item.series.find(item => item?.data?.length)
          if (findLine) {
            return true
          } else {
            return false
          }
        })
        const formatData = handleDateFormat([startTime, endTime], delay)
        if (!formatData) {
          return Promise.resolve(undefined)
        }
        // x轴时间刻度
        let xDate = []
        // 如果查到有返回数据的话，使用返回数据中的时间戳
        if (findLine?.data?.length) {
          xDate = findLine.data.map(({ timestamp }) => timestamp)
        } else {
          // 如果一条数据都没有返回，前端自己计算出x轴时间刻度
          let curTime = startTime / 1000
          while (curTime < endTime / 1000) {
            curTime += delay
            xDate.push(curTime)
          }
        }
        // series数据
        const seriesData = []
        // 聚合后无数据的数据
        const nullData = {}
        // 匹配instanceName跟tag
        // const regex = /-\((.*)\)(-\[([^\]]+)\])?/
        data.forEach(
          ({ graphMetricId, resourceAggregator, tagsAggregator, series, units, metricName }) => {
            if (!resourceAggregator) {
              // 维度聚合方式计算
              if (tagsAggregator) {
                const tagObj = {}
                series.forEach(({ legend, instanceId, data }) => {
                  let nullLine: any = {}
                  const nullTimestamp = []
                  const [instanceName, tag] = getLegnedData(legend)
                  const objKey = `${instanceId}`
                  let datas: any[] = []
                  if (data?.length) {
                    datas = data.map(({ value, timestamp }) => {
                      if (value && value !== 'null') {
                        return keepDecimal(value)
                      } else {
                        nullTimestamp.push(timestamp)
                        return undefined
                      }
                    })
                  } else {
                    nullTimestamp.push(...xDate)
                    datas = new Array(xDate.length)
                  }
                  if (nullTimestamp.length) {
                    nullLine = {
                      tag,
                      instanceId,
                      instanceName,
                      nullTimestamp
                    }
                  }
                  if (tagObj[objKey]) {
                    tagObj[objKey].tags.push(tag)
                    tagObj[objKey].data.push(datas)
                    nullLine?.tag && tagObj[objKey].nullLine.push(nullLine)
                  } else {
                    tagObj[objKey] = {
                      tags: [tag],
                      data: [datas],
                      instanceName,
                      tagAgg: tagsAggregator,
                      metricName,
                      nullLine: nullLine?.tag ? [nullLine] : []
                    }
                  }
                })
                Object.keys(tagObj).forEach((instanceId: string) => {
                  const { tags, data, tagAgg, instanceName, metricName, nullLine } =
                    tagObj[instanceId]
                  const legend = `${metricName}(${instanceName})-[${tags?.join('、')}]-${
                    aggregator_menu[tagsAggregator]
                  }`
                  const calcData = calcAggData(data, xDate, tagAgg)
                  const name = getChartLegend(legend, seriesData, instanceId)
                  if (nullLine?.length) {
                    nullData[name] = nullLine
                  }
                  const seriesObject = {
                    name: `${name}===${units || ''}`,
                    type: 'line',
                    data: xDate.map((date, index) => {
                      const filter = nullLine.filter(({ nullTimestamp }) =>
                        nullTimestamp.includes(date)
                      )
                      return {
                        value: calcData[index],
                        null_data: filter.map(({ instanceId, instanceName, tag }) => {
                          return {
                            instanceId,
                            instanceName,
                            tag
                          }
                        })
                      }
                    }),
                    symbol: 'circle',
                    symbolSize: 4,
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    smpling: 'lttb'
                  }
                  seriesData.push(seriesObject)
                })
              } else {
                series.forEach(({ legend, instanceId, data }) => {
                  const name = getChartLegend(legend, seriesData, instanceId)
                  const seriesObject = {
                    name: `${name}===${units || ''}`,
                    type: 'line',
                    data: data?.length
                      ? data.map(({ value }) =>
                          value && value !== 'null' ? keepDecimal(value) : undefined
                        )
                      : new Array(xDate.length),
                    symbol: 'circle',
                    symbolSize: 4,
                    smooth: true,
                    lineStyle: {
                      width: 2
                    },
                    smpling: 'lttb'
                  }
                  seriesData.push(seriesObject)
                })
              }
            } else {
              // 实例聚合方式
              const nullLine = []
              const aggData = series.map(({ data, instanceId, legend }) => {
                const [instanceName, tag] = getLegnedData(legend)
                if (data?.length) {
                  const nullTimestamp = []
                  const filterNull = data.map(({ timestamp, value }) => {
                    if (value && value !== 'null') {
                      return keepDecimal(value)
                    } else {
                      nullTimestamp.push(timestamp)
                      return undefined
                    }
                  })
                  if (filterNull.includes(undefined)) {
                    nullLine.push({ instanceId, instanceName, tag, nullTimestamp })
                  }
                  return filterNull
                } else {
                  nullLine.push({ instanceId, instanceName, tag, nullTimestamp: xDate })
                  return new Array(xDate.length)
                }
              })
              const calcData = calcAggData(aggData, xDate, resourceAggregator)
              let aggValue: any = 0
              if (calcData?.length) {
                if (resourceAggregator === 'max') {
                  aggValue = keepDecimal(
                    Math.max.apply(
                      null,
                      calcData.filter(item => isNumber(item))
                    ) || null
                  )
                } else if (resourceAggregator === 'min') {
                  aggValue = keepDecimal(
                    Math.min.apply(
                      null,
                      calcData.filter(item => isNumber(item))
                    ) || null
                  )
                } else if (resourceAggregator === 'average') {
                  aggValue = keepDecimal(
                    calcData.reduce((pre, cur = 0) => (pre += cur), 0) / calcData.length || null
                  )
                } else if (resourceAggregator === 'sum') {
                  aggValue = keepDecimal(calcData.reduce((pre, cur = 0) => (pre += cur), 0) || null)
                }
              } else {
                aggValue = 'N/A'
              }
              const legend = `${metricName}#${graphMetricId}-${
                aggregator_menu[resourceAggregator]
              }:${handleUnit(aggValue, units || '')}`
              if (nullLine?.length) {
                nullData[legend] = nullLine
              }
              const seriesObject = {
                name: `${legend}===${units || ''}`,
                type: 'line',
                data: xDate.map((date, index) => {
                  const filter = nullLine.filter(({ nullTimestamp }) =>
                    nullTimestamp.includes(date)
                  )
                  return {
                    value: calcData[index],
                    null_data: filter.map(({ instanceId, instanceName, tag }) => {
                      return {
                        instanceId,
                        instanceName,
                        tag: tag || '无'
                      }
                    })
                  }
                }),
                smooth: true,
                symbol: 'circle',
                symbolSize: 4,
                lineStyle: {
                  width: 2
                },
                smpling: 'lttb',
                resourceAggregator
              }
              seriesData.push(seriesObject)
            }
          }
        )
        return Promise.resolve({
          series: seriesData,
          xData: xDate.map(cur => dayjs(cur * 1000).format(dataFormat || formatData)),
          interval: delay,
          lineCount: params.LineCount,
          nullData
        })
      } else {
        return Promise.reject({
          series: [],
          xData: [],
          interval: delay,
          lineCount: params.LineCount,
          nullData: {}
        })
      }
    },
    []
  )

  return {
    getDashboardChart,
    chartData,
    loading
  }
}

export default getMetricStatisticsBatch
